import { useState, useEffect, useRef } from 'react';
import { FaEnvelope, FaPhone, FaLinkedin, FaFacebook, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import contactPhoto from '../contact photo.jpg';
import './Contact.css';

function Contact() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => new Set([...prev, entry.target.dataset.section]));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    sectionRefs.current.forEach((ref) => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      label: 'Email',
      value: 'malolos.jasminmeghan@gmail.com',
      link: null,
      color: '#1f4788'
    },
    {
      icon: <FaPhone />,
      label: 'Phone',
      value: '09214192040',
      link: 'tel:09214192040',
      color: '#5ba3d0'
    },
    {
      icon: <FaMapMarkerAlt />,
      label: 'Location',
      value: 'San Vicente, Sto. Tomas, Batangas',
      link: null,
      color: '#2d5aa0'
    },
  ];

  const socials = [
    { icon: <FaLinkedin />, label: 'LinkedIn', link: 'https://www.linkedin.com/in/jasmin-meghan-malolos-2783333b7?utm_source=share_via&utm_content=profile&utm_medium=member_ios', color: '#0077b5' },
    { icon: <FaFacebook />, label: 'Facebook', link: 'https://www.facebook.com/jasminmeghan.malolos?mibextid=wwXIfr&rdid=Rs1FcHyLUSqbCirX&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1E4tzGcH33%2F%3Fmibextid%3DwwXIfr', color: '#1877f2' },
  ];


  return (
    <section className="contact-page">
      {/* Header */}
      <div
        className={`contact-header ${visibleSections.has('header') ? 'visible' : ''}`}
        data-section="header"
        ref={(el) => (sectionRefs.current[0] = el)}
      >
        <div className="header-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="contact-header-content">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">Feel free to reach out for collaborations, opportunities, or just to say hello</p>
        </div>
      </div>

      {/* Body */}
      <div className="contact-body">
        <div className="contact-container">
          <div className="contact-grid">
            {/* Left - Info */}
            <div
              className={`contact-info-section ${visibleSections.has('info') ? 'visible' : ''}`}
              data-section="info"
              ref={(el) => (sectionRefs.current[1] = el)}
            >
              <h2 className="contact-info-title">Contact Information</h2>
              <p className="contact-info-subtitle">
                I'm currently open to internship opportunities and project collaborations.
                Don't hesitate to reach out!
              </p>

              <div className="contact-info-cards">
                {contactInfo.map((info, index) => (
                  <div key={index} className="contact-info-card">
                    <div className="info-card-icon" style={{ background: `linear-gradient(135deg, ${info.color}, ${info.color}bb)` }}>
                      {info.icon}
                    </div>
                    <div className="info-card-text">
                      <span className="info-label">{info.label}</span>
                      {info.link ? (
                        <a href={info.link} className="info-value">{info.value}</a>
                      ) : (
                        <span className="info-value">{info.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Links */}
              <div className="contact-socials">
                <h3 className="socials-title">Follow Me</h3>
                <div className="socials-row">
                  {socials.map((social, index) => (
                    <a
                      key={index}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-btn"
                      style={{ '--social-color': social.color }}
                      title={social.label}
                    >
                      {social.icon}
                      <span>{social.label}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Right - Image */}
            <div
              className={`contact-image-section ${visibleSections.has('image') ? 'visible' : ''}`}
              data-section="image"
              ref={(el) => (sectionRefs.current[2] = el)}
            >
              <div className="contact-image-wrapper">
                <img src={contactPhoto} alt="Contact Jasmin" className="contact-photo" />
                <div className="image-overlay-glow"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
